import { defaultFilterCriteria, useSampleFilterStore } from '@/stores/sampleFilterStore';
import { substrateDefaultFilterCriteria, useSubstrateFilterStore } from '@/stores/substrateFilterStore';
import { canReadUserScopedStorage } from '@/lib/browser/userScopedStorage';

/** Reload sample/substrate filter stores from the active user's persisted state. */
export async function rehydrateSampleListFilterStores(): Promise<void> {
  if (!canReadUserScopedStorage()) {
    useSampleFilterStore.setState({
      filters: defaultFilterCriteria,
      paginationModel: { page: 0, pageSize: 25 },
      growthDateSetFromBasicRow: false,
      addedBySetFromBasicRow: false,
    });
    useSubstrateFilterStore.setState({
      filters: substrateDefaultFilterCriteria,
      paginationModel: { page: 0, pageSize: 25 },
      addedBySetFromBasicRow: false,
    });
    return;
  }

  await Promise.all([useSampleFilterStore.persist.rehydrate(), useSubstrateFilterStore.persist.rehydrate()]);
}
